// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "main[data-v-1ec2d600]{position:relative;background:url(/bg-auth.jpg) 50% no-repeat;background-size:cover;margin-top:-50px;width:100%;height:100vh}main[data-v-1ec2d600]:before{content:\"\";position:absolute;top:0;left:0;right:0;bottom:0;height:100vh}@media (min-width:768px){main[data-v-1ec2d600]{margin-top:-90px}}", ""]);
// Exports
module.exports = exports;
